/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ModernCurrencyRatesComponent as ɵb} from './lib/components/modern-currency-rates/modern-currency-rates.component';
export {RateBoardService as ɵa} from './lib/services/rateboard.service';